<script>
import { formatMonto } from "@/utils";

export default {
  name: "ColorType",
  props: {
    row: {
      type: Object,
      default: () => {}
    }
  },
  functional: true,

  render(createElement, context) {
    let { rowValue } = context.data.attrs;
    let { column } = context.data.attrs;
    let { row } = context.props;
    //console.log("context: ", context)

    let dateActually = new Date();
    let year = dateActually.getFullYear();
    let month = String(dateActually.getMonth() + 1).padStart(2, "0"); // Añade cero a la izquierda si es necesario
    let day = String(dateActually.getDate()).padStart(2, "0");
    let hours = String(dateActually.getHours()).padStart(2, "0");
    let minutes = String(dateActually.getMinutes()).padStart(2, "0");
    let seconds = String(dateActually.getSeconds()).padStart(2, "0");

    let formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    let Type = String;
    let Status = String;
    let customStyle = String;

    if (column == "TypeUser") {
      if (rowValue == "PROSPECTO") {
        Type = "black";
        Status = "PROSPECTO";
        customStyle =
          "background-color:rgba(245,245,245); border-radius: 10%; padding-left: 25px; padding-right: 25px; padding-bottom: 15px; padding-top: 15px;";
      } else {
        Type = "black";
        Status = "CLIENTE";
        customStyle =
          "background-color:rgba(253,245,230); border-radius: 10%; padding-left: 25px; padding-right: 25px; padding-bottom: 15px; padding-top: 15px;";
      }

      return createElement(
        "div",
        {
          attrs: {
            name: "",
            class: Type,
            //class: "",
            effect: "light",
            style: customStyle
          }
        },
        Status
      );
    }

    if (column == "CustomerClassification") {
      // Se usa en el reporte de visitas y llamadas para dar colores a la columna CustomerClassification
      switch (rowValue) {
        case 1:
          Type = "Azul";
          Status = "A";
          break;
        case 2:
          Type = "Verde";
          Status = "B";
          break;
        case 3:
          Type = "Naranja";
          Status = "C";
          break;
        case 4:
          Type = "Rojo";
          Status = "D";
          break;
      }

      return createElement(
        "b",
        {
          attrs: {
            name: "",
            class: Type
          }
        },
        Status
      );
    }

    // aunque hasOwnProperty marque un error, el funciona, ese error es de slint no afecta la funcionalidad del codigo
    else if (Object.prototype.hasOwnProperty.call(row, "DiasRetraso")) {
      // Se usa en el reporte de solicitudes externas para dar colores a la columna de Retraso
      switch (row.DiasRetraso) {
        case 0:
          Type = "Verde";
          Status = row.DiasRetraso;
          break;

        default:
          Type = "Rojo";
          Status = row.DiasRetraso;
          break;
      }

      return createElement(
        "b",
        {
          attrs: {
            name: "",
            class: Type
          }
        },
        `${Status}` + " Dias"
      );
    } else if (["balanceDiff", "CxP_Diff"].includes(column)) {
      // Se usa en el reporte de solicitudes externas para dar colores a la columna de Retraso
      if (
        Object.prototype.hasOwnProperty.call(row, "balanceDiff") &&
        column === "balanceDiff"
      ) {
        switch (row.balanceDiff) {
          case 0:
            Type = "Verde";
            Status = row.balanceDiff;
            break;

          default:
            Type = "Rojo";
            Status = row.balanceDiff;
            break;
        }
      }
      if (
        Object.prototype.hasOwnProperty.call(row, "CxP_Diff") &&
        column === "CxP_Diff"
      ) {
        switch (row.CxP_Diff) {
          case 0:
            Type = "Verde";
            Status = row.CxP_Diff;
            break;

          default:
            Type = "Rojo";
            Status = row.CxP_Diff;
            break;
        }
      }

      return createElement(
        "b",
        {
          attrs: {
            name: "",
            class: Type
          }
        },
        formatMonto(Status)
      );
    } else if (
      [
        "totalRecharges",
        "totalConsumption",
        "calculatedBalance",
        "dbBalance",
        "ToTal_ClientPayment",
        "Client_CxPtoSupplier"
      ].includes(column)
    ) {
      // Se usa en el reporte de solicitudes externas para dar colores a la columna de Retraso
      if (
        Object.prototype.hasOwnProperty.call(row, "totalRecharges") &&
        column === "totalRecharges"
      ) {
        if (row.totalRecharges < 0) {
          Type = "Rojo";
          Status = row.totalRecharges;
        } else {
          Type = "Negro";
          Status = row.totalRecharges;
        }
      } else if (
        Object.prototype.hasOwnProperty.call(row, "totalConsumption") &&
        column === "totalConsumption"
      ) {
        if (row.totalConsumption < 0) {
          Type = "Rojo";
          Status = row.totalConsumption;
        } else {
          Type = "Negro";
          Status = row.totalConsumption;
        }
      } else if (
        Object.prototype.hasOwnProperty.call(row, "calculatedBalance") &&
        column === "calculatedBalance"
      ) {
        if (row.calculatedBalance < 0) {
          Type = "Rojo";
          Status = row.calculatedBalance;
        } else {
          Type = "Negro";
          Status = row.calculatedBalance;
        }
      } else if (
        Object.prototype.hasOwnProperty.call(row, "dbBalance") &&
        column === "dbBalance"
      ) {
        if (row.dbBalance < 0) {
          Type = "Rojo";
          Status = row.dbBalance;
        } else {
          Type = "Negro";
          Status = row.dbBalance;
        }
      } else if (
        Object.prototype.hasOwnProperty.call(row, "ToTal_ClientPayment") &&
        column === "ToTal_ClientPayment"
      ) {
        if (row.ToTal_ClientPayment < 0) {
          Type = "Rojo";
          Status = row.ToTal_ClientPayment;
        } else {
          Type = "Negro";
          Status = row.ToTal_ClientPayment;
        }
      } else if (
        Object.prototype.hasOwnProperty.call(row, "Client_CxPtoSupplier") &&
        column === "Client_CxPtoSupplier"
      ) {
        //console.log("Entro a Client_CxPtoSupplier")
        if (row.Client_CxPtoSupplier < 0) {
          //console.log("Entro a la diferencia de balance en Client_CxPtoSupplier")
          Type = "Rojo";
          Status = row.Client_CxPtoSupplier;
        } else {
          Type = "Negro";
          Status = row.Client_CxPtoSupplier;
        }
      } else {
        Type = "Negro";
        Status = row.rowValue;
      }
      return createElement(
        "b",
        {
          attrs: {
            name: "",
            class: Type
          }
        },
        formatMonto(Status)
      );
    } else if (Object.prototype.hasOwnProperty.call(row, "PendingToRateDays")) {
      // Se usa en el reporte de solicitudes sin calificar para dar colores a la columna de dias sin calificar
      switch (row.PendingToRateDays) {
        case 0:
          Type = "Verde";
          Status = row.PendingToRateDays;
          break;

        default:
          Type = "Rojo";
          Status = row.PendingToRateDays;
          break;
      }

      return createElement(
        "b",
        {
          attrs: {
            name: "",
            class: Type
          }
        },
        `${Status}` + " Dias"
      );
    } else if (Object.prototype.hasOwnProperty.call(row, "Actived")) {
      //para modulo semaforo
      //console.log("row", row)
      switch (row.Actived) {
        case true:
          //console.log("entre al caso 0")
          Type = "danger";
          Status = "Inactivo";
          break;
        case false:
          Type = "success";
          Status = "Activo";
          break;
        default:
          break;
      }

      return createElement(
        "el-tag",
        {
          attrs: {
            name: "",
            type: Type
          }
        },
        Status
      );
    } else if (column == "Clasification") {
      //Se usa en la tabla de clientes de la pagina de ventas
      switch (rowValue) {
        case "A":
          Type = "";
          Status = "A";
          break;
        case "B":
          Type = "success";
          Status = "B";
          break;
        case "C":
          //Type = "#f5e10c";
          Status = "C";
          customStyle =
            "background-color:#f5e10c!important;border-color:#f5e10c!important";
          break;
        case "D":
          Type = "warning";
          Status = "D";
          break;
        case "E":
          Type = "danger";
          Status = "E";
          break;
        case "F":
          Type = "info";
          Status = "F";
          break;
      }

      return createElement(
        "el-tag",
        {
          attrs: {
            name: "",
            type: Type,
            style: customStyle,
            //class: "",
            effect: "dark"
          }
        },
        Status
      );
    } else if (
      Object.prototype.hasOwnProperty.call(row, "Clasificacion") &&
      column === "Clasificacion"
    ) {
      if (row.Clasificacion == "A") {
        Type = "Azul";
        Status = "A";
        customStyle =
          "background-color:rgba(29, 255, 255, 0.1); border-radius: 10%; padding-left: 25px; padding-right: 25px; padding-bottom: 15px; padding-top: 15px;";
      } else if (row.Clasificacion == "B") {
        Type = "Verde";
        Status = "B";
        customStyle =
          "background-color:rgba(87, 255, 29, 0.1); border-radius: 10%; padding-left: 25px; padding-right: 25px; padding-bottom: 15px; padding-top: 15px;";
      } else if (row.Clasificacion == "C") {
        Type = "Rojo";
        Status = "C";
        customStyle =
          "background-color:rgba(255, 29, 29, 0.1); border-radius: 10%; padding-left: 25px; padding-right: 25px; padding-bottom: 15px; padding-top: 15px;";
      } else if (row.Clasificacion == "D") {
        Type = "Negro";
        Status = "D";
        customStyle =
          "background-color:rgba(255, 228, 29, 0.1); border-radius: 10%; padding-left: 25px; padding-right: 25px; padding-bottom: 15px; padding-top: 15px;";
      }
      return createElement(
        "div",
        {
          attrs: {
            name: "",
            class: Type,
            style: customStyle,
            effect: "dark"
          }
        },
        Status
      );
    } else if (
      Object.prototype.hasOwnProperty.call(row, "DayInvoice") &&
      column === "DayInvoice"
    ) {
      if (row.DayInvoice <= 10) {
        Type = "Naranja";
        Status = row.DayInvoice;
      } else if (row.DayInvoice <= 20) {
        Type = "Rojo";
        Status = row.DayInvoice;
      } else if (row.DayInvoice <= 25) {
        Type = "Azul";
        Status = row.DayInvoice;
      } else {
        Type = "Verde";
        Status = row.DayInvoice;
      }
      return createElement(
        "a",
        {
          attrs: {
            name: "",
            class: Type,
            effect: "dark"
          }
        },
        Status
      );
    } else if (
      Object.prototype.hasOwnProperty.call(row, "TotalAmount") &&
      column === "TotalAmount"
    ) {
      if (row.TotalAmount !== "") {
        Type = "Verde";
        Status = row.TotalAmount;
        customStyle =
          "background-color:rgba(87, 255, 29, 0.1); border-radius: 10%; padding-left: 25px; padding-right: 25px; padding-bottom: 15px; padding-top: 15px;";
      }
      return createElement(
        "div",
        {
          attrs: {
            name: "",
            class: Type,
            style: customStyle,
            effect: "dark"
          }
        },
        formatMonto(Status)
      );
    } else if (
      Object.prototype.hasOwnProperty.call(row, "Amount") &&
      column === "Amount"
    ) {
      if (row.Amount !== "") {
        Type = "Verde";
        Status = row.Amount;
        customStyle =
          "background-color:rgba(87, 255, 29, 0.1); border-radius: 10%; padding-left: 25px; padding-right: 25px; padding-bottom: 15px; padding-top: 15px;";
      }
      return createElement(
        "div",
        {
          attrs: {
            name: "",
            class: Type,
            style: customStyle,
            effect: "dark"
          }
        },
        formatMonto(Status)
      );
    } else if (
      Object.prototype.hasOwnProperty.call(row, "Quantity") &&
      column === "Quantity"
    ) {
      if (row.Quantity !== "") {
        Type = "Verde";
        Status = row.Quantity;
        customStyle =
          "background-color:rgba(87, 255, 29, 0.1); border-radius: 10%; padding-left: 25px; padding-right: 25px; padding-bottom: 15px; padding-top: 15px;";
      }
      return createElement(
        "div",
        {
          attrs: {
            name: "",
            class: Type,
            style: customStyle,
            effect: "dark"
          }
        },
        formatMonto(Status)
      );
    } else if (
      Object.prototype.hasOwnProperty.call(row, "Paid") &&
      column === "Paid"
    ) {
      //let dateActually = new Date();
      //row.PayDay = new Date(row.PayDay);
      if (row.Paid == false && row.PayDay < formattedDate) {
        Type = "Rojo";
        Status = "Vencido";
        customStyle =
          "background-color:rgba(255,0,0,0.1); border-radius: 10%; padding-left: 25px; padding-right: 25px; padding-bottom: 15px; padding-top: 15px;";
      } else if (row.Paid == false) {
        Type = "Amarillo";
        Status = "Pendiente";
        customStyle =
          "background-color:rgba(255,255,0,0.1); border-radius: 10%; padding-left: 25px; padding-right: 25px; padding-bottom: 15px; padding-top: 15px;";
      } else if (row.Paid == true) {
        Type = "Verde";
        Status = "Ejecutado";
        customStyle =
          "background-color:rgba(87, 255, 29, 0.1); border-radius: 10%; padding-left: 25px; padding-right: 25px; padding-bottom: 15px; padding-top: 15px;";
      }
      return createElement(
        "div",
        {
          attrs: {
            name: "",
            class: Type,
            style: customStyle,
            effect: "dark"
          }
        },
        Status
      );
    }

    // else if (column === "PaymentDay") {
    //   switch(rowValue) {
    //     case "10D":
    //       Type = "";
    //       Status = rowValue;
    //       break;
    //   }

    //   return createElement(
    //     "el-tag",
    //     {
    //       attrs: {
    //         name: "",
    //         type: Type
    //       }
    //     },
    //     Status
    //   );
    // }
    else {
      // Se usa en el card de servicio al cliente  para dar colores a los porcentajes de visitas y llamadas
      if (Number(row) >= 0 && Number(row) < 80) {
        Type = "Rojo";
      } else if (Number(row) >= 80 && Number(row) < 90) {
        Type = "Naranja";
      } else if (Number(row) >= 90 && Number(row) <= 100) {
        Type = "Verde";
      } else {
        Type = "Azul";
      }
      /*
      switch (Number(row)) {

        case row > 50:
          Type = "Verde";

          break;
        case 3:
          Type = "Naranja";

          break;
        case row < 50:
          Type = "Rojo";

          break;
      };
      */
      return createElement(
        "b",
        {
          attrs: {
            name: "",
            class: Type
          }
        },
        `${row}` + " %"
      );
    }
  }
};
</script>
<style scoped>
.Azul {
  color: blue;
}
.Verde {
  color: green;
}
.amarillo {
  background-color: #f5e10c;
}
.Naranja {
  color: orange;
}
.Rojo {
  color: rgba(255, 0, 0, 0.712);
}
.Negro {
  color: #606266;
}
</style>
